import {useMemo} from "react";
import {LocationContext} from "../model/location/location-context";
import {useGetAllCurrentLocationsQuery} from "../store/location/location-context-store";
import {locationContextsSelector} from "../store/location/selectors";
import {ApiError, extractApiError} from "../util/error-util";

export type UseFleetTrackingProps = {
  regionId?: string
  type: "PERSON" | "TRAILER" | "VEHICLE"
}

export type UseFleetTrackingResult = {
  locations?: LocationContext[]
  isLoading: boolean,
  isFetching: boolean
  refetch?: any,
  error?: ApiError
}

export const useFleetTracking = (props: UseFleetTrackingProps): UseFleetTrackingResult => {
  const {
    regionId,
    type,
  } = props;

  const selectLocationContexts = useMemo(() => {
    return locationContextsSelector()
  }, []);

  const {locations, isLoading, isFetching, error, refetch} = useGetAllCurrentLocationsQuery({
    regionId: regionId,
    entityType: type
  }, {
    pollingInterval: 30000,
    selectFromResult: (result) => ({
      ...result,
      locations: selectLocationContexts(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
      error: result.error ? extractApiError(result.error) : undefined,
    })
  });

  return {
    locations: locations,
    isLoading: isLoading,
    isFetching: isFetching,
    error: error,
    refetch: refetch,
  };
};
